import React, { useEffect, useContext, useState, useActionState } from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Input_Text_Long from '../ERUMAUI/UI_Input_Text_Long';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import UI_Button from '../ERUMAUI/UI_Button';
import { useAuth } from '../../Contexts/AuthContext';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import { useStatus } from '../../Contexts/Context_Status_Global';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_ChipGroup from '../ERUMAUI/UI_ChipGroup';
import UI_UpdatingStatus from '../ERUMAUI/UI_UpdatingStatus';

export default function Subwindow_ScheduleManagement_Conflict_Resolve_Standard({ zIndex, isActive, id }) {
    const UI = useContext(Context_UI);
    const { Account } = useAuth();
    const { List_Unsaved, List_Unsaved_Set, Status_Saving, Unsaved_Clear } = useStatus();
    const { Template_List } = useTemplating();
    const { Buildings, Floors, Rooms, Map_Composition, Room_Find, Room_Highlight, Get_Parent_Index } = useMapRenderer();
    const { Reservation, Reservation_Set, Reservation_Save, Reservation_Step, Reservation_Step_Set, Reservation_Clear, Conflicts, Time_Range_Parse, Status_Parse, Conflict_Recommendation, Conflict_Recommendation_Get, Time_Parse } = useScheduleManagement();


    const Close = async () => {
        UI.Subwindows_Close(id);
    }

    const [Working_Buildings, Working_Buildings_Set] = useState([]);
    const [Working_Floors, Working_Floors_Set] = useState([]);
    const [Working_Rooms, Working_Rooms_Set] = useState([]);
    const [SelectedLabels, SelectedLabels_Set] = useState({
        building: null,
        floor: null,
        room: null,
    });
    useEffect(() => {
        const Handle = ({ List_ID, Value, Value_Index }) => {
            switch (List_ID) {
                case "Schedule_Building": {
                    const b = Map_Composition[Value_Index];
                    if (!b) return;
                    // cascade arrays
                    Working_Floors_Set(b.Floors || []);
                    Working_Rooms_Set([]);
                    // update labels
                    SelectedLabels_Set({ building: b.Name, floor: null, room: null });
                    // clear room selection in reservation
                    Reservation_Set(prev => ({ ...prev, RoomID: "" }));
                    break;
                }
                case "Schedule_Floor": {
                    const f = Working_Floors[Value_Index];
                    if (!f) return;
                    Working_Rooms_Set(f.Rooms || []);
                    SelectedLabels_Set(prev => ({ ...prev, floor: f.Name, room: null }));
                    Reservation_Set(prev => ({ ...prev, RoomID: "" }));
                    break;
                }
                case "Schedule_Room": {
                    const r = Working_Rooms[Value_Index];
                    if (!r) return;
                    SelectedLabels_Set(prev => ({ ...prev, room: r.Name }));
                    Reservation_Set(prev => ({ ...prev, RoomID: r._id }));
                    // optional: mirror on the map
                    // Room_Highlight(r._id, 1.6, 400, "Directory");
                    break;
                }
                default:
                    break;
            }
        };

        UI.on("Dropdown_Value_Submitted", Handle);
        return () => UI.off("Dropdown_Value_Submitted", Handle);
    }, [UI, Map_Composition, Working_Floors, Working_Rooms, Reservation_Set, Reservation]);

    useEffect(() => {
        const Structure = Get_Parent_Index(Reservation.RoomID);
        if (!Structure) return;

        SelectedLabels_Set(prev => ({
            ...prev,
            building: Map_Composition[Structure.Index_Building].Name,
            floor: Map_Composition[Structure.Index_Building]?.Floors[Structure.Index_Floor].Name || null,
            room: Map_Composition[Structure.Index_Building].Floors[Structure.Index_Floor].Rooms[Structure.Index_Room].Name
        }));

        Working_Floors_Set(Map_Composition[Structure.Index_Building]?.Floors);
        Working_Rooms_Set(Map_Composition[Structure.Index_Building]?.Floors[Structure.Index_Floor].Rooms);
    }, [Reservation.RoomID, Map_Composition]);


    const Handle_Time_Change = async (e) => {
        const { id, value } = e.target;

        Reservation_Set((prev) => {
            let newStart = new Date(prev.Time.Start);
            let newEnd = new Date(prev.Time.End);

            if (id === "Schedule_Date_Changeable") {
                // Update both Start & End with new date, preserve hours/minutes
                const [year, month, day] = value.split("-").map(Number);
                newStart.setFullYear(year, month - 1, day);
                newEnd.setFullYear(year, month - 1, day);
            }

            if (id === "Schedule_Start_Changeable") {
                const [hours, minutes] = value.split(":").map(Number);
                newStart.setHours(hours, minutes, 0, 0);
            }

            if (id === "Schedule_End_Changeable") {
                const [hours, minutes] = value.split(":").map(Number);
                newEnd.setHours(hours, minutes, 0, 0);
            }

            return {
                ...prev,
                Time: {
                    Start: newStart,
                    End: newEnd,
                },
                DateModified: new Date()
            };
        });
        // await Conflict_Check();
    };


    const Format_Time = (date, Type) => {
        if (!(date instanceof Date) || isNaN(date)) return "";
        const pad = (n) => String(n).padStart(2, "0");
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());

        switch (Type) {
            case "date":
                return `${year}-${month}-${day}`;
            case "time":
                return `${hours}:${minutes}`;
            case "datetime-local":
                return `${year}-${month}-${day}T${hours}:${minutes}`;
            default:
                return "";
        }
    }

    const Format_Location = () => {
        // console.log(SelectedLabels);
        return `${SelectedLabels.building}, ${SelectedLabels.floor}, ${SelectedLabels.room}`;
    }

    function Format_TimeRange(start, end) {
        const opts = { hour: "numeric", minute: "2-digit", hour12: true };
        return `${start.toLocaleTimeString([], opts)} - ${end.toLocaleTimeString([], opts)}`;
    }

    function Format_Date(date) {
        const opts = { weekday: "short", year: "numeric", month: "long", day: "2-digit" };
        return date.toLocaleDateString(undefined, opts);
    }

    useEffect(() => {
        Conflict_Recommendation_Get();
    }, [Reservation]);

    const [Reservation_Changeable, Reservation_Changeable_Set] = useState({
        Start: Format_Time(Reservation.Time.Start, "time"),
        End: Format_Time(Reservation.Time.End, "time"),
        Date: Format_Time(Reservation.Time.Start, "date")
    })

    const Suggestion_Accept = (Data, Type) => {
        if (Type === "Time") {
            const Start = new Date(Data.Start);
            const End = new Date(Data.End);

            Reservation_Changeable_Set({
                Start,
                End,
                Date: Start
            });
            Reservation_Set(prev => ({ ...prev, Time: { Start, End }, Date: Start }));
        } 
        if (Type === "Room") {
            Reservation_Set(prev => ({ ...prev, RoomID: Data._id }));
        }
    };

    // useEffect(() => {
    //     Conflict_Recommendation_Get();
    // }, []);

    return (
        <ui-subwindow Type='Subwindow' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    Resolve conflict
                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Close}>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content style={{ minHeight: "700px", paddingRight: "10px" }}>
                <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                    {Conflicts.Hard.length + Conflicts.Soft.length > 0 ?
                        <UI_ChipGroup
                            Items={[{
                                Text: `There are ${Conflicts.Hard.length + Conflicts.Soft.length} conflicts.`,
                                Color: "Red"
                            }]} />
                        :
                        <UI_ChipGroup
                            Items={[{
                                Text: `There are no conflicts.`,
                                Color: "Green"
                            }]} />
                    }
                </div>
                <div className='General_Split' Split="3">
                    <div>
                        <UI_Divider Text="Your requested schedule" />
                        <UI_Form Composition="ByTwo">
                            {/* <UI_Divider Text="Location" DoubleColumns={true} /> */}
                            <UI_Dropdown
                                id="Schedule_Building"
                                Label_Text="Building:"
                                InitialTitle="Building"
                                Items={Map_Composition}
                                Item_Key="Name"
                                Selected={SelectedLabels.building}
                                Fill
                            />
                            <UI_Dropdown
                                id="Schedule_Floor"
                                Label_Text="Floor:"
                                InitialTitle="Floor"
                                Items={Working_Floors}
                                Item_Key="Name"
                                Selected={SelectedLabels.floor}
                                Fill
                            />
                            <UI_Dropdown
                                id="Schedule_Room"
                                Label_Text="Room:"
                                InitialTitle="Room"
                                Items={Working_Rooms}
                                Item_Key="Name"
                                Selected={SelectedLabels.room}
                                Fill />
                            <span></span>
                            <UI_Button
                                Icon={<UI_Icon Name="Map" />}
                                Icon_Position="Left"
                                Text="Choose from the map"
                                OnClick={() => UI.Subwindows_Open("Window_ScheduleManagement_Map")} />
                            {/* <UI_Divider Text="Schedule" DoubleColumns={true} /> */}
                            <UI_Input_Text
                                id="Schedule_Start_Changeable"
                                Label_Text="Start time:"
                                Input_Type='time'
                                Value_Set_Enable={true}
                                Value={Format_Time(Reservation.Time.Start, "time")}
                                 />
                            <UI_Input_Text
                                id="Schedule_End_Changeable"
                                Label_Text="End time:"
                                Input_Type='time'
                                Value_Set_Enable={true}
                                Value={Format_Time(Reservation.Time.End, "time")}
                                 />
                            <UI_Input_Text
                                id="Schedule_Date_Changeable"
                                Label_Text="Date:"
                                Input_Type='date'
                                Value_Set_Enable={true}
                                Value={Format_Time(Reservation.Time.Start, "date")}
                                PreventPast={true}
                                 />
                        </UI_Form>
                    </div>
                    <div>
                        <UI_Divider Text="Conflicting schedules" />
                        <UI_UpdatingStatus
                            State={Conflicts.Hard.length + Conflicts.Soft.length > 0 ? "Bad" : "Good"}
                            Good={{
                                Type: "Default",
                                Icon: "Default",
                                Title: "No schedule conflicts",
                                Text: "No schedule conflict detected. You can continue with your reservation."
                            }}
                            Bad={{
                                Type: "Custom",
                                Content: <div className='General_List'>
                                    {Conflicts.Hard.map((Item) => (
                                        <UI_Card
                                            Type="Schedule_List"
                                            Figure={
                                                {
                                                    Title: Item.Name,
                                                    Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                    Chip: Status_Parse(Item)
                                                }
                                            }
                                        />
                                    ))}
                                    {Conflicts.Soft.map((Item) => (
                                        <UI_Card
                                            Type="Schedule_List"
                                            Figure={
                                                {
                                                    Title: Item.Name,
                                                    Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                    Chip: Status_Parse(Item)
                                                }
                                            }
                                        />
                                    ))}
                                </div>
                            }}
                        />
                        

                    </div>
                    <div className='General_Split' Split="2" Orientation="Vertical">
                        <div>
                            <UI_Divider Text="Time slot suggestions" />
                            <UI_UpdatingStatus
                                State={Conflicts.Hard.length + Conflicts.Soft.length > 0 ? "Bad" : "Good"}
                                Good={{
                                    Type: "Default",
                                    Icon: "Default",
                                    Title: "No schedule conflicts",
                                    Text: "No schedule conflict detected. You can continue with your reservation."
                                }}
                                Bad={{
                                    Type: "Custom",
                                    Content: <>
                                        <p className='General_Paragraph' style={{ marginBottom: "20px" }}>
                                            Click a suggestion below to apply it to your reservation
                                        </p>
                                        <div className='General_List'>
                                            {Conflict_Recommendation?.Time?.map((Item) => (
                                                <UI_Card
                                                    Type="Schedule_List"
                                                    Figure={
                                                        {
                                                            Title: Time_Range_Parse(Item.Start, Item.End, "Time"),
                                                            Main: Time_Parse(Item.Start, "Date"),
                                                            Chip: []
                                                        }
                                                    }
                                                    onClick={() => Suggestion_Accept(Item, "Time")}
                                                />
                                            ))}
                                        </div>
                                    </>
                                }}
                            />
                            

                        </div>
                        <div>
                            <UI_Divider Text="Room suggestions" />
                            <UI_UpdatingStatus
                                State={Conflicts.Hard.length + Conflicts.Soft.length > 0 ? "Bad" : "Good"}
                                Good={{
                                    Type: "Default",
                                    Icon: "Default",
                                    Title: "No schedule conflicts",
                                    Text: "No schedule conflict detected. You can continue with your reservation."
                                }}
                                Bad={{
                                    Type: "Custom",
                                    Content: <>
                                        <div className='General_List'>
                                            {Conflict_Recommendation?.Room?.map((Item) => (
                                                <UI_Card
                                                    Type="Schedule_List"
                                                    Figure={
                                                        {
                                                            Title: Item.Name,
                                                            Main: "",
                                                            Chip: []
                                                        }
                                                    }
                                                    onClick={() => Suggestion_Accept(Item, "Room")}
                                                />
                                            ))}
                                        </div>
                                    </>
                                }}
                            />
                            
                        </div>
                    </div>

                </div>


            </ui-subwindow-content>
            <ui-subwindow-controls>
                {Conflicts.Hard.length + Conflicts.Soft.length > 0 ?
                    <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Close}>
                        Cancel
                    </button>
                    :
                    <button className='General_Button Subwindow_Control' Type='Primary' State={Conflicts.Hard.length + Conflicts.Soft.length > 0 ? "Negative" : "Positive"} onClick={Close}>
                        Close
                    </button>
                }   
                
                
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
